import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import {
    StockAlmacenENTITY,
    StockAlmacenEquiposENTITY,
    StockPersonalENTITY,
    StockPersonalEquiposENTITY
} from 'sigo-entities'
import { AdapterConfigureGenerico } from './AdapterConfigureGenerico'
import { transformErrorResponse } from './transformErrorResponse'

export const logisticaApi = createApi({
    reducerPath: 'logisticaApi',
    baseQuery: fetchBaseQuery({
        baseUrl: AdapterConfigureGenerico.URL_BASE_LOGISTICA,
        prepareHeaders: (headers) => {
            headers.set('Content-Type', 'application/json')
            headers.set('request-decrypt-response', 'true')
            return headers
        },
    }),
    endpoints: (build) => ({
        findStockPersonal: build.mutation<StockPersonalENTITY[], { pais: string, delegacion: string, pipeline: any[] }>({
            query: ({ pais, delegacion, pipeline }) => ({
                url: `/Reportes/StockPersonal/find/${pais}/${delegacion}`,
                method: 'POST',
                body: { filter: pipeline },
            }),
            transformErrorResponse
        }),
        findOneStockPersonalEquipos: build.mutation<StockPersonalEquiposENTITY, { pais: string, delegacion: string, pipeline: any[] }>({
            query: ({ pais, delegacion, pipeline }) => ({
                url: `/Reportes/StockPersonalEquipos/findone/${pais}/${delegacion}`,
                method: 'POST',
                body: pipeline,
            }),
            transformErrorResponse
        }),
        findStockPersonalEquipos: build.query<StockPersonalEquiposENTITY, { pais: string, delegacion: string, pipeline: any[] }>({
            query: ({ pais, delegacion, pipeline }) => ({
                url: `/Reportes/StockPersonalEquipos/findone/${pais}/${delegacion}`,
                method: 'POST',
                body: pipeline,
            }),
            transformErrorResponse
        }),
        findStockAlmacen: build.mutation<StockAlmacenENTITY[], { pais: string, delegacion: string, pipeline: any[] }>({
            query: ({ pais, delegacion, pipeline }) => ({
                url: `/Reportes/StockAlmacen/find/${pais}/${delegacion}`,
                method: 'POST',
                body: { filter: pipeline },
            }),
            transformErrorResponse
        }),
        findStockAlmacenWithTransit: build.mutation<StockAlmacenENTITY[], { pais: string, delegacion: string, pipeline: any[] }>({
            query: ({ pais, delegacion, pipeline }) => ({
                url: `/Reportes/StockAlmacen/find-with-transit/${pais}/${delegacion}`,
                method: 'POST',
                body: pipeline,
            }),
            transformErrorResponse
        }),
        findOneStockAlmacenEquipos: build.mutation<StockAlmacenEquiposENTITY, { pais: string, delegacion: string, pipeline: any[] }>({
            query: ({ pais, delegacion, pipeline }) => ({
                url: `/Reportes/StockAlmacenEquipos/findone/${pais}/${delegacion}`,
                method: 'POST',
                body: pipeline,
            }),
            transformErrorResponse
        }),
        findStockAlmacenEquipos: build.mutation<StockAlmacenEquiposENTITY[], { pais: string, delegacion: string, pipeline: any[] }>({
            query: ({ pais, delegacion, pipeline }) => ({
                url: `/Reportes/StockAlmacenEquipos/find/${pais}/${delegacion}`,
                method: 'POST',
                body: { filter: pipeline },
            }),
            transformErrorResponse
        }),
        findStockPersonalEquiposAux: build.mutation<StockPersonalEquiposENTITY[], { pais: string, delegacion: string, pipeline: any[] }>({
            query: ({ pais, delegacion, pipeline }) => ({
                url: `/Reportes/StockPersonalEquipos/find/${pais}/${delegacion}`,
                method: 'POST',
                body: { filter: pipeline },
            }),
            transformErrorResponse
        }),
        findStockPersonalWithTransit: build.mutation<StockPersonalENTITY[], { pais: string, delegacion: string, pipeline: any[] }>({
            query: ({ pais, delegacion, pipeline }) => ({
                url: `/Reportes/StockPersonal/find-with-transit/${pais}/${delegacion}`,
                method: 'POST',
                body: pipeline,
            }),
            transformErrorResponse
        }),
    })
})

export const {
    useFindStockPersonalMutation,
    useFindOneStockPersonalEquiposMutation,
    useFindStockPersonalEquiposQuery,
    useFindStockAlmacenMutation,
    useFindStockAlmacenWithTransitMutation,
    useFindOneStockAlmacenEquiposMutation,
    useFindStockAlmacenEquiposMutation,
    useFindStockPersonalEquiposAuxMutation,
    useFindStockPersonalWithTransitMutation
} = logisticaApi
